import "@fontsource/titillium-web";
import { createTheme } from "@mui/material/styles";

/*
    rem to px conversion
    0.25: 4px
    0.125: 2px
    0.5: 8px
    0.75: 12px
    1: 16px
    1.5: 24px
    2: 32px
    139: 8.6875
    37: 2.3125
*/

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#fff",
      contrastText: "#1E1F4A",
    },
    secondary: {
      main: "#56CCF2",
    },
    error: {
      main: "#FF0404",
    },
    success: {
      main: "#74D800",
      light: "#139E64",
      dark: "#436E59",
    },
  },

  typography: {
    allVariants: {
      fontFamily: ["Titillium Web", "sans-serif"].join(","),
      fontStyle: "normal",
      fontWeight: 400,
    },
    fontSize: 16,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Titillium Web';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Titillium Web'), local('Titillium Web-Regular'),
        }
      `,
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '&.error .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#D65C5C',
            },
            '&:hover fieldset': {
              borderColor: '#D65C5C',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#D65C5C',
            },
          },
          "&.error": {
            background: "rgba(214, 92, 92, 0.2)",
          }
        }
      }
    },
    MuiImageListItem: {
      styleOverrides: {
        root: {
          "& img": {
            border: "2px solid transparent",
          },
          "& .selected": {
            border: "2px solid #FFFFFF",
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& .MuiSelect-icon": {
            visibility: 'hidden',
          }
        }
      }
    }
  },
});
